import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Table,
    TextLink,
    TextInput,
    SearchButton,
    LightTextButton,
    FilterDropdown,
    PageNavigator,
    Search
} from "components";
import {customersAction, subscriptionAction} from "redux/actions";
import {useHistory} from "react-router-dom";
import {adminToken} from "../../../helper";
import {internalSearch} from "helper";
import styles from "./styles.module.scss";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
import {Modal} from "@material-ui/core";
import SendInvoice from "./SendInvoice";
import UpdateServiceDatePopup from "../modals/UpdateServiceDatePopup";
import UpdateServiceAddressPopup from "../modals/UpdateServiceAddressPopup";
import axios from "axios";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";
import GoogleMapWithAutocomplete from "../../../components/GoogleMap/GoogleMapWithAutocomplete";

const initialState = {
    cartID: "",
    id: "",
    status: "",
    search: ""
};

export default function Orders() {
    // Routers
    const {push} = useHistory();

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [filterState, setfilterState] = useState(initialState);

    // Redux actions
    const dispatch = useDispatch();
    const {subscription, userRole} = useSelector(state => ({
        subscription: state.subscription,
        userRole: state.userRole?.filter(role => role.module === "Orders")
    }));
    const currDate = new Date().toLocaleDateString();
    const [spLoader, setSpLoader] = useState(false);
    const [searchData, setSearchData] = useState('');
    const [cPage, setCPage] = useState(1);
    const [refresh, setRefresh] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [cities, setCities] = useState({});

    const [subscriptionDatas, setsubscriptionDatas] = useState([])
    
    const [openModalSDT, setOpenModalSDT] = useState(false);
    const handleOpenModalSDT = () => {
        setOpenModalSDT(true)
    }
    const handleCloseSDT = () => {
        setOpenModalSDT(false)
    }

    const [openModalSAdd, setOpenModalSAdd] = useState(false);
    const handleOpenModalSAdd = () => {
        setOpenModalSAdd(true)
    }
    const handleCloseSAdd = () => {
        setOpenModalSAdd(false)
    }

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read")){
            setSpLoader(true);
            adminToken().then(token => axios
                .get(
                    `${AWS_SERVER_APIS}/getallsubscriptions?per_page=10&page=${cPage}&filter=${filterState?.cartID}&from_date=${filterState?.from_date}&to_date=${filterState?.to_date}&city=${filterState?.city}&status=${filterState?.status}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                .then(res => {
                
                    setsubscriptionDatas(res.data);
                    setLastPage(res.data.maxPages);
                    var datacity = ['All'];
                    res.data.cities.map( (item) => {
                        datacity.push(item.city_name);
                    })
                    setCities(datacity);
                    if(res.data.maxPages == 1 || res.data.maxPages < cPage){
                        setCPage(1);
                    }
                    
                    //dispatch(serviceProviderAction.get(1,100000000))
                    setSpLoader(false);
                })
            )
        }
    }, [filterState,cPage,refresh])

    useEffect(() => {
        localStorage.removeItem('orderID');
        const now = new Date();
        const firstDate = new Date(now.getFullYear(), 1, -29);
        const lasttDate = new Date(now.getFullYear(), 12, 1);
        
        //filterState.cartID = 234;
        filterState.from_date = firstDate.toISOString().split('T')[0];
        filterState.to_date = lasttDate.toISOString().split('T')[0];
        filterState.city = 'Bengaluru';
        filterState.status = 'all';

        // if (userRole?.find(item => item.privilege === "Read"))
        //     dispatch(subscriptionAction.get(1));
        // return () => dispatch(subscriptionAction.reset());
    }, []); 

    useEffect(() => {
        let filtered = subscriptionDatas?.subscriptions;
        if (!filtered?.length) {
            setTableRows();
            return;
        }

        // filtered = internalSearch(filterState, "cartID", filtered);
        // filtered = internalSearch(filterState, "id", filtered);
        // filtered = internalSearch(filterState, "status", filtered);

        
        
        // Map table rows
        filtered = filtered?.map(obj => ({
            cartID: (
                <TextLink
                    text={obj.cartID}
                    onClick={() => {
                        localStorage.setItem("spID", obj.id)
                        localStorage.setItem("orderID", obj.cartID)
                        push(`/orders/orders?orderID=${obj.cartID}&spID=${obj.id}`)
                    }}
                />
            ),
            id: (
                <TextLink
                    text={obj.id}
                    onClick={() => {
                        setClickedSubscription({id: obj?.id, userId: null})
                        handleOpenSubscriptionModal()
                        // push(`/subscription/orders/${obj.id}`)
                    }}
                />
            ),
            status: obj.status,
            category: obj.categoryName,
            subcategory: obj.subCategoryName,
            city: obj.city,
            serviceDate: obj.serviceDate,
            serviceTime: obj.serviceTime,
            createdAt: `${new Date(obj.createdAt).toLocaleString()}`,
            updatedAt: `${new Date(obj.updatedAt).toLocaleString()}`,
            reschedCount: obj.reschedCount,
            invoiceBtn: <SendInvoice orderId={obj.id} status={obj.status}/>,
            action:<> <button
                        className={"btn btn-primary w-75 btn-primary"}
                        onClick={() => {
                            handleOpenModalSDT(true);
                            setCurrentSubID(obj.id);
                        }}
                        style={{textTransform: 'capitalize', minWidth: "106px", fontSize: "12px", marginBottom: "5px", padding: "0px"}}>
                        Date Time
                    </button>

                    <button
                        className={"btn btn-primary w-75 btn-success"}
                        onClick={() => {
                            handleOpenModalSAdd(true);
                            setCurrentSubID(obj.id);
                            setCurrentSubcartID(obj.cartID);
                        }}
                        style={{textTransform: 'capitalize', minWidth: "106px", fontSize: "12px", padding: "0px"}}>
                        Service Address
                    </button>
                    
                    
                </>
        }));

        setTableRows(filtered);
    }, [subscription,subscriptionDatas, filterState]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Order",
                sortBy: "cartID"
            },
            {
                title: "Subscription",
                sortBy: "id"
            },
            {
                title: "Status"
            },
            {
                title: "Category"
            },
            {
                title: "Sub Category"
            },
            {
                title: "City"
            },
            {
                title: "Service Date",
                sortBy: "serviceDate"
            },
            {
                title: "Service Time"
            },
            {
                title: "Created",
                sortBy: "createdAt"
            },
            {
                title: "Updated",
                sortBy: "updatedAt"
            },
            {
                title: "ReScheduled Count"
            },
            {
                title: "Invoice"
            },
            {
                title: "Action"
            }
        ],
        [tableRows]
    );

    const onChange = e =>
        setfilterState({...filterState, [e.target.name]: e.target.value});

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [currentSubID, setCurrentSubID] = useState(null)
    const [currentSubcartID, setCurrentSubcartID] = useState(null)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    return (
        <div>
            <div className={styles.filter}>
                <div style={{ borderRight: '1px solid #555', marginRight: '15px', marginTop: '5px', paddingBottom: '0' }}>
                <TextInput
                    label="From Date"
                    name="from_date"
                    type="date"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.from_date}
                />

                <TextInput
                    label="To Date"
                    name="to_date"
                    type="date"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.to_date}
                />

                <FilterDropdown
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    label="City"
                    name="city"
                    value={filterState?.city}
                    options={cities}
                    values={cities}
                />
                
                <FilterDropdown
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    label="Status"
                    name="status"
                    value={filterState?.status}
                    options={[
                        "All",
                        "Scheduled",
                        "ReScheduled",
                        "Routed",
                        "ProviderAssigned",
                        "ProviderOnTheWay",
                        "ProviderArrived",
                        "ProviderOTPSent",
                        "ProviderOTPConfirmed",
                        "InProgress",
                        "AdditionalCharges",
                        "Completed"
                    ]}
                    values={[
                        "all",
                        "Scheduled",
                        "ReScheduled",
                        "Routed",
                        "ProviderAssigned",
                        "ProviderOnTheWay",
                        "ProviderArrived",
                        "ProviderOTPSent",
                        "ProviderOTPConfirmed",
                        "InProgress",
                        "AdditionalCharges",
                        "Completed"
                    ]}
                />
                </div>

                <div>
                <TextInput
                    search
                    label="Order/Subscription"
                    name="cartID"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 200}}
                    value={filterState?.cartID}
                />
                </div>
                
                
                {/* <SearchButton/> */}
                {/* <LightTextButton onClick={() => setfilterState(initialState)}/> */}
            </div>
            <Table
                headers={tableHeaders}
                data={tableRows}
                current={subscription?.currentPage}
                totalPage={0}
                onPageChange={pageNumber =>
                    dispatch(subscriptionAction.get(pageNumber))
                }
                state={filterState !== initialState}
                length={tableRows?.length}
                r_length={subscription?.subscriptions?.length}
                t_length={subscription?.maxPages}

            />

                {(tableRows && !spLoader)?<PageNavigator
                    pageCount={lastPage}
                    currentPage={cPage}
                    onClick={e => {setCPage(e)}}
                />:''}

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openModalSDT}
                onClose={handleCloseSDT}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <UpdateServiceDatePopup tableRows={subscriptionDatas?.subscriptions} handleCloseSDT={handleCloseSDT} currentSubID={currentSubID} />
            </Modal>

            <Modal
                open={openModalSAdd}
                onClose={handleCloseSAdd}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <UpdateServiceAddressPopup tableRows={subscriptionDatas?.subscriptions} handleCloseSAdd={handleCloseSAdd} currentSubID={currentSubID} currentSubcartID={currentSubcartID} setRefresh={setRefresh} />
            </Modal>

            
        </div>
    );
}
